export const PROHIBITED_DOMAINS = ['gmail.com'];
